import {
    Card as ChakraCard,
    Center,
    Flex,
    Heading,
    SystemStyleObject,
    Text,
} from '@chakra-ui/react';

import { CardProps } from './card.props';

import { Image } from '../../atoms';

export const Card = ({
    badge,
    heading,
    headingSize,
    subheading,
    imageProps,
    bodyProps,
    headingProps,
    footerProps,
    ...cardProps
}: CardProps): JSX.Element => {
    return (
        <ChakraCard.Root {...cardProps}>
            {imageProps?.src && <Image {...imageProps} objectFit="cover" />}
            <ChakraCard.Body p={2} {...bodyProps}>
                <div>
                    {(heading || subheading) && (
                        <ChakraCard.Header px={0} py={2} {...headingProps}>
                            {(cardProps?.direction as SystemStyleObject['flexDirection']) ===
                            'column' ? (
                                <Flex justifyContent={'space-between'}>
                                    {heading && <Heading size={headingSize}>{heading}</Heading>}
                                    {badge && <Center flexShrink={0}>{badge}</Center>}
                                </Flex>
                            ) : (
                                <>
                                    {badge && <Flex pb={2}>{badge}</Flex>}
                                    {heading && <Heading size={headingSize}>{heading}</Heading>}
                                </>
                            )}
                            {subheading && <Text fontSize={'sm'}>{subheading}</Text>}
                        </ChakraCard.Header>
                    )}

                    {cardProps.children}

                    {footerProps && <ChakraCard.Footer px={0} py={2} {...footerProps} />}
                </div>
            </ChakraCard.Body>
        </ChakraCard.Root>
    );
};
